import NetPositionsActions from "@frameworks/web/redux/feature/PostLogin/actions/NetPositions";
import PortfolioCompositionActions from "@frameworks/web/redux/feature/PostLogin/actions/PortfolioComposition";
import ContributionActions from "@frameworks/web/redux/feature/PostLogin/actions/Contribution";
import IndexDetailsActions from "@frameworks/web/redux/feature/PostLogin/actions/IndexDetails";
import MarketMapPLActions from "@frameworks/web/redux/feature/PostLogin/actions/MarketMapPL";
import ServiceListActions from "@frameworks/web/redux/feature/PostLogin/actions/ServiceList";
import DiversifyPortfolioActions from "@frameworks/web/redux/feature/PostLogin/actions/DiversifyPortfolio";
import AllIndicesListActions from "@frameworks/web/redux/feature/PostLogin/actions/AllIndicesList";
import UpcomingEventsActions from "@frameworks/web/redux/feature/PostLogin/actions/UpcomingEvents";
export default () => {
    return {
        postLogin: {
            positions: new NetPositionsActions(),
            portfolio: new PortfolioCompositionActions(),
            contribution: new ContributionActions(),
            indexDetails: new IndexDetailsActions(),
            marketMapPL: new MarketMapPLActions(),
            serviceList: new ServiceListActions(),
            diversifyPortfolio: new DiversifyPortfolioActions(),
            allIndicesList: new AllIndicesListActions(),
            upcomingEvents: new UpcomingEventsActions(),
        },
    };
};
